import './styles.scss';

import { useEffect, useState } from 'react';

import IssueFormHistoryTableColumns from '@/features/IssueHistory/components/IssueHistoryForm/IssueFormHistoryTable/IssueFormHistoryTableColumns';
import IssueFormHistoryTableRow from '@/features/IssueHistory/components/IssueHistoryForm/IssueFormHistoryTable/IssueFormHistoryTableRow';
import { IssueHistoryFormDefinitions } from '../types';
import { IssueHistoryRow } from '@/features/IssueHistory';
import Provider from '@/common/Provider';
import SimpleTable from '@/components/SimpleTable';
import { refetchDispatchIssueWithDocuments } from '@/features/IssueHistory/api/services/searchDispatchIssue';

const IssueFormHistoryTable = ({
  onEditDispatchIssue,
  id,
  driverFirstName,
  driverLastName,
  vehicleTrackingId,
}: {
  onEditDispatchIssue?: (accident: IssueHistoryFormDefinitions.Value) => void;
  id: string;
  driverFirstName: string;
  driverLastName: string;
  vehicleTrackingId: string;
}): JSX.Element => {
  const [{ loading, data }, setState] = useState({ loading: false, data: new Map() });
  const getHistory = async (id: string): Promise<void> => {
    try {
      setState((prevState) => ({ ...prevState, loading: true }));
      const res = await refetchDispatchIssueWithDocuments([{ id }]);
      setState((current) => {
        const data = new Map<string, IssueHistoryRow>(res.rows.map((issue) => [issue.id, issue]));
        return { ...current, data };
      });
    } catch (err) {
      console.error('Error getting history:', err);
    } finally {
      setState((prevState) => ({ ...prevState, loading: false }));
    }
  };

  useEffect((): void => {
    if (!id) return;
    getHistory(id);
  }, [id]);

  return (
    <Provider value={{ data, driverFirstName, driverLastName, vehicleTrackingId }} methods={() => ({ onEditDispatchIssue })}>
      <SimpleTable
        className="IssueHistoryFormHistoryTable"
        rows={Array.from(data.keys())}
        columns={IssueFormHistoryTableColumns}
        row={IssueFormHistoryTableRow}
      />
    </Provider>
  );
};

export default IssueFormHistoryTable;
